export default __webpack_public_path__ + "static/builder_tablet@2x-875442431fecd8c13a26568f9032601f.png";